function closeFaqItem(item) {
    const toggle = item.querySelector('[data-faq-toggle]');
    const answer = item.querySelector('.faq__answer');

    if (!toggle || !answer) {
        return;
    }

    item.classList.remove('faq__item--open');
    toggle.setAttribute('aria-expanded', 'false');
    answer.setAttribute('hidden', '');
}

function openFaqItem(item) {
    const toggle = item.querySelector('[data-faq-toggle]');
    const answer = item.querySelector('.faq__answer');

    if (!toggle || !answer) {
        return;
    }

    item.classList.add('faq__item--open');
    toggle.setAttribute('aria-expanded', 'true');
    answer.removeAttribute('hidden');
}

function initFaq() {
    document.querySelectorAll('[data-faq]').forEach((faqList) => {
        const items = faqList.querySelectorAll('.faq__item');

        items.forEach((item) => {
            const toggle = item.querySelector('[data-faq-toggle]');

            if (!toggle) {
                return;
            }

            toggle.addEventListener('click', () => {
                const isOpen = item.classList.contains('faq__item--open');

                items.forEach((otherItem) => {
                    if (otherItem !== item) {
                        closeFaqItem(otherItem);
                    }
                });

                if (isOpen) {
                    closeFaqItem(item);
                } else {
                    openFaqItem(item);
                }
            });
        });
    });
}

initFaq();
